import { render, staticRenderFns } from "./Core_oriental_lacquer.vue?vue&type=template&id=01a2a252&scoped=true&"
import script from "./Core_oriental_lacquer.vue?vue&type=script&lang=js&"
export * from "./Core_oriental_lacquer.vue?vue&type=script&lang=js&"
import style0 from "./Core_oriental_lacquer.vue?vue&type=style&index=0&id=01a2a252&lang=scss&scoped=true&"
import style1 from "./Core_oriental_lacquer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a2a252",
  null
  
)

export default component.exports